import React, { useCallback, useEffect, useRef } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Welcome from './features/welcome/Welcome';
import OnePageLanding from './features/welcome/OnePageLanding';
import { useDispatch } from 'react-redux';
import { setActivePage } from './features/ui/uiSlice';
import landingTypesList from './helper/landingTypes';
const NameScreen = React.lazy(() => import('./features/family/NameScreen'));
const Location = React.lazy(() => import('./features/options/Location'));
const PlaceAlerts = React.lazy(() => import('./features/options/PlaceAlerts'));
const FindLoved = React.lazy(() => import('./features/options/FindLoved'));
const ShareFlight = React.lazy(() => import('./features/options/ShareFlight'));
const EmergencyAlerts = React.lazy(() => import('./features/options/EmergencyAlerts'));
const ChooseTarget = React.lazy(() => import('./features/family/ChooseTarget'));
const CreatePlace = React.lazy(() => import('./features/family/CreatePlace'));
const SignupScreen = React.lazy(() => import('./features/signup/SignupScreen'));
const AddPlace = React.lazy(() => import('./features/family/AddPlace'));
const ErrorScreen = React.lazy(() => import('./features/checkout/ErrorScreen'));
const MapScreen = React.lazy(() => import('./features/plans/map/MapScreen'));
const CreatingProfile = React.lazy(() => import('./features/family/CreatingProfile'));
const SuccessScreen = React.lazy(() => import('./features/success/SuccessScreen'));
const PlanCheckout = React.lazy(() => import("./features/PlanCheckout/PlanCheckout"));

const Router = ({history}) => {
    const dispatch = useDispatch();
    const routes = [
        {
            path: landingTypesList,
            component: Welcome,
        },
        {
            path: '/one-pager',
            component: OnePageLanding,
        },
        {
            path: '/signup',
            component: SignupScreen,
        },
        {
            path: '/name',
            component: NameScreen
        },
        {
            path: '/location',
            component: Location
        },
        {
            path: '/place-alerts',
            component: PlaceAlerts
        },
        {
            path: '/find-loved',
            component: FindLoved
        },
        {
            path: '/flight-status',
            component: ShareFlight
        },
        {
            path: '/auto-sos',
            component: EmergencyAlerts
        },
        {
            path: '/choose-your-target',
            component: ChooseTarget
        },
        {
            path: '/create-place',
            component: CreatePlace
        },
        {
            path: '/add-place',
            component: AddPlace
        },
        {
            path: '/creating-your-profile',
            component: CreatingProfile
        },
        {
            path: '/plans/map',
            component: MapScreen
        },
        {
            path: '/checkout',
            component: PlanCheckout,
        },
        {
            path: '/checkout/error',
            component: ErrorScreen
        },
        {
            path: '/checkout/success',
            component: SuccessScreen,
        },
    ];
    const {location: {pathname}} = history;

    const locationHistory = useRef([history.location.pathname]);

    const setPath = useCallback((path) => {
        dispatch(setActivePage(path.replace('/','')))
    }, [dispatch]);

    useEffect(() => setPath(pathname),[pathname, dispatch, setPath]);

    useEffect(() => {
        history?.listen((newLocation, action) => {
            let {current} = locationHistory,
                path = newLocation.pathname,
                prevPath = current[current.length - 1];

            if (path !== prevPath) {
                if (action === "PUSH") {
                    if (!current.includes(path)) {
                        window.scrollTo(0,0);
                        locationHistory.current.push(path);
                        window.sessionStorage.setItem('locationHistory',locationHistory.current);
                    } else {
                        locationHistory.current = current.slice(0,current.indexOf(path)+1);
                        window.sessionStorage.setItem('locationHistory',locationHistory.current);
                    }
                } else {
                    path = prevPath;
                }

                history.push({pathname: path});
            }
        });
    }, [history]);

    return (
        <Switch>
            {routes.map((route, i) => <Route exact key={i} {...route}/>)}
        </Switch>
    )
};

export default withRouter(Router);
